import { render, staticRenderFns } from "./AuthFormFieldAttribute.vue?vue&type=template&id=151a8361&scoped=true"
import script from "./AuthFormFieldAttribute.vue?vue&type=script&lang=js"
export * from "./AuthFormFieldAttribute.vue?vue&type=script&lang=js"
import style0 from "./AuthFormFieldAttribute.vue?vue&type=style&index=0&id=151a8361&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a8361",
  null
  
)

export default component.exports